/* eslint-disable @typescript-eslint/no-unused-vars, unused-imports/no-unused-vars  */
import { type ReactElement } from 'react';

import { type Event } from '@clubspark-node/clubspark-tennis-types';

import { type LevelConfiguration } from 'atoms/tournament';
import {
  type ScaleAttributes,
  type ScaleTypeEnum,
} from 'components/panels/eventsSplitDraws/selectedEvent/rankingsAndRatings/types';
import { type ScaleItem } from 'typedefs/store/tmxTypes';

import {
  type ParticipantScaling,
  type ScalingOptions,
  type ScalingPurpose,
  type ScalingTypeOptions,
  type SubScalingType,
} from '.';

export default class Scaling {
  static scaleName: string;
  static scaleType: ScaleTypeEnum;
  static sortDirection: 'normal' | 'inverted' = 'normal';
  static defaultScaleValue = undefined;
  static getScaleAttributes(scaleNameFn: (scaleName: string) => string, event: Event): ScaleAttributes {
    return {
      scaleName: scaleNameFn(this.scaleName),
      scaleType: this.scaleType,
      eventType: event?.eventType,
    };
  }
  static scaleSortMethod(
    purpose: ScalingPurpose,
    a: ParticipantScaling<ScaleItem>,
    b: ParticipantScaling<ScaleItem>,
    options: ScalingTypeOptions,
  ): number {
    return 0;
  }
  public static getDisplay(
    participantScaling: ParticipantScaling,
    options?: ScalingTypeOptions,
  ): string | ReactElement {
    return '-';
  }
  public static getText(participantScaling: ParticipantScaling, options?: ScalingTypeOptions): string {
    return '-';
  }
  public static getValue(participantScaling: ParticipantScaling, options?: ScalingTypeOptions): number {
    return null;
  }
  public static getIsAvailable(event: Event, levelConfig?: LevelConfiguration): boolean {
    return true;
  }

  public static getDisplayName = (options?: ScalingOptions): string => 'scale name';

  public static getSubScalings = (): SubScalingType[] | typeof undefined => undefined;
}
